<template>
  <main-template>
    <v-row class="mb-2">
      <v-col cols="12" class="d-flex align-center justify-space-between flex-wrap">
        <h1 class="text-h5 font-weight-bold d-flex align-center">
          <v-btn color="primary" icon text class="mr-2" @click="$router.go(-1)">
            <v-icon>fa fa-angle-left</v-icon>
          </v-btn>
          <v-icon color="primary" class="mr-2">mdi-clock-check-outline</v-icon>
          Gerenciar Justificativas de Atraso
        </h1>
        <v-btn color="primary" outlined small @click="carregar" :loading="loading">
          <v-icon left small>mdi-refresh</v-icon>
          Atualizar Lista
        </v-btn>
      </v-col>
    </v-row>

    <v-row dense class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-lg pa-3">
          <div class="d-flex justify-space-between align-center">
            <div>
              <div class="caption font-weight-bold grey--text text-uppercase">
                Total de Ocorrências
              </div>
              <div class="text-h4 font-weight-bold primary--text">{{ estatisticas.total }}</div>
            </div>
            <v-avatar color="blue lighten-5" size="44">
              <v-icon color="primary">mdi-format-list-bulleted</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-lg pa-3">
          <div class="d-flex justify-space-between align-center">
            <div>
              <div class="caption font-weight-bold grey--text text-uppercase">
                Pendentes de Análise
              </div>
              <div class="text-h4 font-weight-bold warning--text">{{ estatisticas.pendentes }}</div>
            </div>
            <v-avatar color="amber lighten-5" size="44">
              <v-icon color="amber darken-3">mdi-clock-alert-outline</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-lg pa-3">
          <div class="d-flex justify-space-between align-center">
            <div>
              <div class="caption font-weight-bold grey--text text-uppercase">Aprovadas</div>
              <div class="text-h4 font-weight-bold success--text">{{ estatisticas.aprovadas }}</div>
            </div>
            <v-avatar color="green lighten-5" size="44">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-lg pa-3">
          <div class="d-flex justify-space-between align-center">
            <div>
              <div class="caption font-weight-bold grey--text text-uppercase">Rejeitadas</div>
              <div class="text-h4 font-weight-bold error--text">{{ estatisticas.rejeitadas }}</div>
            </div>
            <v-avatar color="red lighten-5" size="44">
              <v-icon color="error">mdi-close-circle-outline</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card outlined class="rounded-lg mb-4">
      <v-card-title
        class="py-2 px-4 bg-grey lighten-5 caption font-weight-bold text-uppercase grey--text"
      >
        Filtros de Pesquisa
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-3 px-4">
        <v-row dense align="center">
          <v-col cols="12" sm="4" md="3">
            <v-text-field
              v-model="filtros.search"
              label="Buscar Colaborador..."
              prepend-inner-icon="mdi-magnify"
              dense
              outlined
              hide-details
              clearable
              @keyup.enter="carregar"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="filtros.status"
              :items="statusOpcoes"
              label="Status"
              dense
              outlined
              hide-details
              clearable
              @change="carregar"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4" md="2">
            <e-date-customize
              v-model="filtros.data_inicio"
              label="Data Início"
              dense
              outlined
              hide-details
              clearable
              @change="carregar"
            />
          </v-col>

          <v-col cols="12" sm="4" md="2">
            <e-date-customize
              v-model="filtros.data_fim"
              label="Data Fim"
              dense
              outlined
              hide-details
              clearable
              @change="carregar"
            />
          </v-col>

          <v-col cols="12" sm="4" md="2" class="d-flex">
            <v-btn color="primary" class="w-100 font-weight-bold" @click="carregar">
              <v-icon left small>mdi-filter-variant</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="rounded-lg">
      <v-data-table
        :headers="headers"
        :items="justificativas"
        :loading="loading"
        loading-text="Carregando justificativas de atraso..."
        no-data-text="Nenhuma justificativa encontrada para os filtros aplicados."
        class="elevation-0"
      >
        <template v-slot:item.colaborador="{ item }">
          <div class="d-flex align-center py-2">
            <v-avatar color="primary lighten-4" size="32" class="mr-2">
              <span class="primary--text font-weight-bold caption">
                {{ getIniciais(item.colaborador ? item.colaborador.name : "") }}
              </span>
            </v-avatar>
            <div>
              <div class="font-weight-bold grey--text text--darken-3">
                {{ item.colaborador ? item.colaborador.name : "N/A" }}
              </div>
              <div
                class="caption grey--text"
                v-if="item.solicitante && item.solicitante.id !== item.colaborador_id"
              >
                Enviado por: {{ item.solicitante.name }}
              </div>
            </div>
          </div>
        </template>

        <template v-slot:item.data="{ item }">
          <span class="font-weight-medium">
            {{ formatarData(item.data) }}
          </span>
        </template>

        <template v-slot:item.hora_prevista="{ item }">
          <span>{{ item.hora_prevista || "-" }}</span>
        </template>

        <template v-slot:item.hora_registrada="{ item }">
          <span class="error--text font-weight-bold">{{ item.hora_registrada || "-" }}</span>
        </template>

        <template v-slot:item.tempo_atraso="{ item }">
          <v-chip x-small color="warning" class="font-weight-bold white--text">
            {{ item.tempo_atraso || formatarMinutos(item.minutos_atraso) }}
          </v-chip>
        </template>

        <template v-slot:item.motivo="{ item }">
          <span class="text-truncate d-inline-block" style="max-width: 200px" :title="item.motivo">
            {{ item.motivo }}
          </span>
        </template>

        <template v-slot:item.anexo="{ item }">
          <v-btn
            v-if="item.anexo"
            color="info"
            text
            x-small
            class="font-weight-bold"
            @click="abrirAnexo(item.id)"
          >
            <v-icon left x-small>mdi-paperclip</v-icon>
            Anexo
          </v-btn>
          <span v-else class="caption grey--text">Sem anexo</span>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            small
            :color="getStatusColor(item.status)"
            class="font-weight-bold white--text text-capitalize"
          >
            {{ formatarStatus(item.status) }}
          </v-chip>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="caption grey--text">
            {{ formatarDataHora(item.created_at) }}
          </span>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-btn
            v-if="item.status === 'pendente'"
            color="primary"
            small
            class="font-weight-bold"
            @click="abrirDetalhes(item)"
          >
            <v-icon left small>mdi-gavel</v-icon>
            Avaliar
          </v-btn>
          <v-btn v-else color="grey" text small @click="abrirDetalhes(item)">
            <v-icon left small>mdi-eye-outline</v-icon>
            Detalhes
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <atraso-justificado-detail-dialog
      v-model="dialogDetalhes"
      :atraso="itemSelecionado"
      modo-gestor
      @avaliado="carregar"
    />
  </main-template>
</template>

<script>
import AtrasoJustificadoDetailDialog from "@/components/Colaboradores/AtrasoJustificadoDetailDialog.vue";

export default {
  name: "GerenciarAtrasosJustificadosPage",
  components: { AtrasoJustificadoDetailDialog },
  data() {
    return {
      loading: false,
      justificativas: [],
      filtros: {
        search: "",
        status: null,
        data_inicio: "",
        data_fim: "",
      },
      statusOpcoes: [
        { text: "Todos os Status", value: null },
        { text: "Pendentes", value: "pendente" },
        { text: "Aprovadas", value: "aprovado" },
        { text: "Rejeitadas", value: "rejeitado" },
      ],
      dialogDetalhes: false,
      itemSelecionado: null,
      headers: [
        { text: "Colaborador", value: "colaborador", sortable: true },
        { text: "Data", value: "data", sortable: true },
        { text: "Hora Prevista", value: "hora_prevista", sortable: false },
        { text: "Hora Registrada", value: "hora_registrada", sortable: false },
        { text: "Tempo Atraso", value: "tempo_atraso", sortable: true },
        { text: "Motivo", value: "motivo", sortable: false },
        { text: "Anexo", value: "anexo", sortable: false },
        { text: "Status", value: "status", sortable: true },
        { text: "Envio", value: "created_at", sortable: true },
        { text: "Ações", value: "acoes", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    estatisticas() {
      const total = this.justificativas.length;
      const pendentes = this.justificativas.filter((j) => j.status === "pendente").length;
      const aprovadas = this.justificativas.filter((j) => j.status === "aprovado").length;
      const rejeitadas = this.justificativas.filter((j) => j.status === "rejeitado").length;
      return { total, pendentes, aprovadas, rejeitadas };
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.loading = true;
        const res = await this.$services.colaboradorPontosService.adminListarAtrasosJustificados(
          this.filtros
        );
        this.justificativas = Array.isArray(res) ? res : [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async abrirAnexo(id) {
      try {
        await this.$services.colaboradorPontosService.adminAbrirAnexoAtraso(id);
      } catch (error) {
        this.$handleError(error);
      }
    },
    abrirDetalhes(item) {
      this.itemSelecionado = item;
      this.dialogDetalhes = true;
    },
    getIniciais(nome) {
      if (!nome) return "CO";
      const partes = nome.trim().split(" ");
      if (partes.length >= 2) {
        return (partes[0][0] + partes[1][0]).toUpperCase();
      }
      return nome.substring(0, 2).toUpperCase();
    },
    formatarData(dataStr) {
      if (!dataStr) return "-";
      const partes = dataStr.split("-");
      if (partes.length === 3) {
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
      }
      return dataStr;
    },
    formatarDataHora(dateTimeStr) {
      if (!dateTimeStr) return "-";
      try {
        const d = new Date(dateTimeStr);
        return `${d.toLocaleDateString("pt-BR")} ${d.toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      } catch (e) {
        return dateTimeStr;
      }
    },
    formatarMinutos(minutos) {
      if (!minutos) return "00h00m";
      const h = Math.floor(minutos / 60);
      const m = minutos % 60;
      return `${String(h).padStart(2, "0")}h${String(m).padStart(2, "0")}m`;
    },
    formatarStatus(status) {
      const map = {
        pendente: "Pendente",
        aprovado: "Aprovada",
        rejeitado: "Rejeitada",
      };
      return map[status] || status;
    },
    getStatusColor(status) {
      const map = {
        pendente: "amber darken-2",
        aprovado: "success",
        rejeitado: "error",
      };
      return map[status] || "grey";
    },
  },
};
</script>
